import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=5bdf596e&scoped=true&component=true&componentId=index5fa6267c"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index5fa6267c"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index5fa6267c"
import style0 from "./index.mpx?vue&type=style&index=0&id=5bdf596e&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m5fa6267c%22%7D&component=true&componentId=index5fa6267c"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf596e",
  null
  
)

export default component.exports